/**
 * Converts the values of an enum to a human-readable array
 * @param enumObject the enum you want converted to an array of strings
 * @example
 * enum TestStatus {
 *     PENDING,
 *     OK,
 *     FAILED
 * }
 * console.log(...enumToArray(TestStatus)); // prints: "PENDING"  "OK"  "FAILED"
 * @example
 * enum TestStatus {
 *     PENDING = "pending",
 *     OK = "ok",
 *     FAILED = "failed"
 * }
 * console.log(...enumToArray(TestStatus)); // prints: "pending"  "ok"  "failed"
 */
export function enumToArray(enumObject) {
    return Object.values(enumObject).filter((k) => typeof k === 'string');
}
//# sourceMappingURL=enums.js.map